<template>
  <router-link v-if="to.name" class="select-item" :to="to">
    <v-icon :name="isLoading ? 'loading' : icon"/>
    {{ name }}
  </router-link>

  <div v-else class="select-item" @click="handleClick">
    <v-icon :name="isLoading ? 'loading' : icon"/>
    {{ name }}
  </div>
</template>

<script>
import message from "@/utils/message";

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'edit',
    },
    name: {
      type: String,
      default: '修改',
    },
    to: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: String,
      default: '',
    },
  },
  methods: {
    async handleClick() {
      if (this.isLoading) return;

      if (this.message) {
        const isCancel = await message({ message: this.message });
        if (isCancel) return;
      }

      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.avatar {
  object-fit: cover;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 35px;
  background: #f5f5f5;
  color: #e4e6e6;
}
</style>
